"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LinkedRdfSourcesAsyncRdfIterator_1 = require("./LinkedRdfSourcesAsyncRdfIterator");
/**
 * An quad iterator that can iterate over consecutive RDF sources
 * that are determined using the rdf-resolve-hypermedia-links bus.
 *
 * @see LinkedRdfSourcesAsyncRdfIterator
 */


var MediatedLinkedRdfSourcesAsyncRdfIterator =
/*#__PURE__*/
function (_LinkedRdfSourcesAsyn) {
  _inherits(MediatedLinkedRdfSourcesAsyncRdfIterator, _LinkedRdfSourcesAsyn);

  function MediatedLinkedRdfSourcesAsyncRdfIterator(cacheSize, context, forceSourceType, subject, predicate, object, graph, firstUrl, mediators) {
    var _this;

    _classCallCheck(this, MediatedLinkedRdfSourcesAsyncRdfIterator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MediatedLinkedRdfSourcesAsyncRdfIterator).call(this, cacheSize, subject, predicate, object, graph, firstUrl, {
      autoStart: false
    }));
    _this.context = context;
    _this.forceSourceType = forceSourceType;
    _this.mediatorRdfDereference = mediators.mediatorRdfDereference;
    _this.mediatorMetadata = mediators.mediatorMetadata;
    _this.mediatorMetadataExtract = mediators.mediatorMetadataExtract;
    _this.mediatorRdfResolveHypermedia = mediators.mediatorRdfResolveHypermedia;
    _this.mediatorRdfResolveHypermediaLinks = mediators.mediatorRdfResolveHypermediaLinks;
    _this.handledUrls = {};
    return _this;
  }

  _createClass(MediatedLinkedRdfSourcesAsyncRdfIterator, [{
    key: "getNextUrls",
    value: function () {
      var _getNextUrls = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(metadata) {
        var _this2 = this;

        var _ref, urls;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.mediatorRdfResolveHypermediaLinks.mediate({
                  context: this.context,
                  metadata: metadata
                });

              case 3:
                _ref = _context.sent;
                urls = _ref.urls;
                return _context.abrupt("return", urls.filter(function (url) {
                  if (_this2.handledUrls[url]) {
                    return false;
                  } else {
                    _this2.handledUrls[url] = true;
                    return true;
                  }
                }));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", []);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function getNextUrls(_x) {
        return _getNextUrls.apply(this, arguments);
      }

      return getNextUrls;
    }()
  }, {
    key: "getNextSource",
    value: function () {
      var _getNextSource = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(url, handledDatasets) {
        var context, rdfDereferenceOutput, rdfMetadataOuput, _ref2, metadata, _ref3, source, dataset;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Get the RDF representation of the given document
                context = this.context;
                _context2.next = 3;
                return this.mediatorRdfDereference.mediate({
                  context: context,
                  url: url
                });

              case 3:
                rdfDereferenceOutput = _context2.sent;
                url = rdfDereferenceOutput.url; // Determine the metadata

                _context2.next = 7;
                return this.mediatorMetadata.mediate({
                  context: context,
                  url: url,
                  quads: rdfDereferenceOutput.quads,
                  triples: rdfDereferenceOutput.triples
                });

              case 7:
                rdfMetadataOuput = _context2.sent;
                _context2.next = 10;
                return this.mediatorMetadataExtract.mediate({
                  context: context,
                  url: url,
                  metadata: rdfMetadataOuput.metadata
                });

              case 10:
                _ref2 = _context2.sent;
                metadata = _ref2.metadata;
                _context2.next = 14;
                return this.mediatorRdfResolveHypermedia.mediate({
                  context: context,
                  forceSourceType: this.forceSourceType,
                  handledDatasets: handledDatasets,
                  metadata: metadata,
                  quads: rdfMetadataOuput.data,
                  url: url
                });

              case 14:
                _ref3 = _context2.sent;
                source = _ref3.source;
                dataset = _ref3.dataset;

                if (dataset) {
                  // Mark the dataset as applied
                  // This is needed to make sure that things like QPF search forms are only applied once,
                  // and next page links are followed after that.
                  handledDatasets[dataset] = true;
                }

                return _context2.abrupt("return", {
                  source: source,
                  metadata: metadata,
                  handledDatasets: handledDatasets
                });

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getNextSource(_x2, _x3) {
        return _getNextSource.apply(this, arguments);
      }

      return getNextSource;
    }()
  }]);

  return MediatedLinkedRdfSourcesAsyncRdfIterator;
}(LinkedRdfSourcesAsyncRdfIterator_1.LinkedRdfSourcesAsyncRdfIterator);

exports.MediatedLinkedRdfSourcesAsyncRdfIterator = MediatedLinkedRdfSourcesAsyncRdfIterator;